import React, { useState, useEffect } from 'react';

const JSONBIN_ID = '69750825ae596e708ff2d523';
const JSONBIN_URL = `https://api.jsonbin.io/v3/b/${JSONBIN_ID}`;
const JSONBIN_KEY = '$2a$10$zWeDCcv/08dfJKpRyW6lv.HE2MG/Q9KitKQ6falrFUU.0z3UuDqCG';

export default function EpicOverview({ onNavigate }) {
  const [ideas, setIdeas] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const statusColors = {
    'exploration': { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Exploration' },
    'it-design': { bg: 'bg-orange-100', text: 'text-orange-700', label: 'IT-Design' },
    'prioritization': { bg: 'bg-purple-100', text: 'text-purple-700', label: 'Prioritization' },
    'execution': { bg: 'bg-green-100', text: 'text-green-700', label: 'Execution' }
  };

  const ideaConfig = {
    supervisie: {
      icon: '👨‍⚕️',
      path: 'supervisie',
      defaultTitle: 'Proactieve Supervisie'
    },
    salarisverwerking: {
      icon: '💶',
      path: 'salarisverwerking',
      defaultTitle: 'Salarisverwerking Vereenvoudigen'
    }
  };

  useEffect(() => {
    loadIdeas();
  }, []);

  const loadIdeas = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(JSONBIN_URL + '/latest', {
        headers: { 'X-Master-Key': JSONBIN_KEY }
      });
      if (response.ok) {
        const data = await response.json();
        if (data.record?.ideas) {
          setIdeas(data.record.ideas);
        }
      }
    } catch (error) {
      console.log('Load failed:', error);
    }
    setIsLoading(false);
  };

  const getStatusInfo = (status) => statusColors[status] || statusColors['exploration'];

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-gray-500">Laden...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="max-w-4xl mx-auto">
        
        {/* Header */}
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center">
              <span className="text-white text-2xl">💡</span>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-800">Ideation Funnel</h1>
              <p className="text-gray-500">Overzicht van alle klantwensen in de pipeline</p>
            </div>
          </div>
        </div>

        {/* Funnel Stats */}
        <div className="grid grid-cols-4 gap-4 mb-6">
          {Object.entries(statusColors).map(([key, config]) => {
            const count = Object.values(ideas).filter(i => i.status === key).length;
            return (
              <div key={key} className="bg-white rounded-xl shadow-sm p-4">
                <div className={`inline-block px-2 py-1 rounded text-xs font-medium ${config.bg} ${config.text} mb-2`}>
                  {config.label}
                </div>
                <div className="text-2xl font-bold text-gray-800">{count}</div>
                <div className="text-sm text-gray-500">ideeën</div>
              </div>
            );
          })}
        </div>

        {/* Ideas List */}
        <div className="bg-white rounded-xl shadow-sm p-6">
          <h2 className="font-semibold text-gray-800 mb-4">Alle Ideeën</h2>
          
          <div className="space-y-3">
            {Object.entries(ideaConfig).map(([key, config]) => {
              const idea = ideas[key] || { 
                id: `IDEA-${key === 'supervisie' ? '002' : '003'}`,
                title: config.defaultTitle,
                status: 'exploration',
                owner: 'Niet toegewezen'
              };
              const statusInfo = getStatusInfo(idea.status);
              
              return (
                <div 
                  key={key}
                  onClick={() => onNavigate && onNavigate(config.path)}
                  className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                      <span className="text-xl">{config.icon}</span>
                    </div>
                    <div>
                      <div className="flex items-center gap-2">
                        <span className="text-xs text-gray-400 font-mono">{idea.id}</span>
                        <span className={`px-2 py-0.5 rounded text-xs font-medium ${statusInfo.bg} ${statusInfo.text}`}>
                          {statusInfo.label}
                        </span>
                      </div>
                      <h3 className="font-medium text-gray-800">{idea.title}</h3>
                      <p className="text-sm text-gray-500">Eigenaar: {idea.owner}</p>
                    </div>
                  </div>
                  <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              );
            })}
          </div>
        </div>

        {/* Refresh Button */}
        <div className="mt-4 text-center">
          <button 
            onClick={loadIdeas}
            className="text-sm text-gray-500 hover:text-orange-500 transition"
          >
            🔄 Vernieuwen
          </button>
        </div>

      </div>
    </div>
  );
}
